/**
 * Map UI i18n language to the locale expected by the SecondApi backend.
 *
 * The site uses `hy` for Armenian internally, but the second backend
 * expects `am` (ISO country code for Armenia). Other locales pass through.
 */
export function getSecondApiLocale(lang) {
  const normalized = (lang || "").toLowerCase();
  if (normalized === "hy") return "am";
  return normalized || "en";
}
